export { default as BpRegistrationSlot } from './BpRegistrationSlot';
